module.exports = __webpack_public_path__ + "img/round-512x512.b7c1baa4.png";